import * as Yup from "yup";
import { formModel } from "./formModel";
import { cieKeys } from "./cieKeys";
import { validations } from "utils";

export const getValidationSchema = ({ intl }, cie) => {
  const {
    fields: {
      concept,
      amount,
      email,
      validity,
      referenceNumeric,
      referenceAlphanumeric,
    },
  } = formModel({ intl });

  return Yup.object().shape({
    [concept.name]: Yup.string().required(`${concept.requiredErrorMsg}`),
    [amount.name]: validations.amountWithMin.required(
      `${amount.requiredErrorMsg}`
    ),
    [email.name]: Yup.string()
      .email(email.invalidErrorMsg)
      .required(`${email.requiredErrorMsg}`),
    [validity.name]: Yup.date().required(`${validity.requiredErrorMsg}`),
    ...(cie === cieKeys[1].key && {
      [referenceNumeric.name]: Yup.string()
        .matches(/^\d+$/, {
          message: intl.formatMessage({ id: "common.fieldMustBeANumber" }),
        })
        .required(`${referenceNumeric.requiredErrorMsg}`),
    }),
    ...(cie === cieKeys[2].key && {
      [referenceAlphanumeric.name]: Yup.string()
        .required(`${referenceAlphanumeric.requiredErrorMsg}`)
        .max(
          7,
          intl.formatMessage(
            { id: "common.fieldLengthMustBeBellow" },
            { length: 8 }
          )
        ),
    }),
  });
};
